import React, { FC, useEffect, useState } from 'react';
import { Colors, ListItem, Text, View } from 'react-native-ui-lib';
import { MaterialIcons } from '@expo/vector-icons';
import { select } from '@react-native-material/core';

export type ListItemProps = {
  onPress: Function,
  label?: string,
  icon?: any,
  selected?: boolean,
  correct?: boolean,
  testID?: string,
}

export function CourseItem({ title, description, handlePress, premium, testID }: { title: string, description?: string, handlePress: Function, premium?: boolean, testID?: string }): JSX.Element {
  return (
    <ListItem testID={testID} height={45} onPress={() => handlePress()} backgroundColor={Colors.tertiaryBG} style={{ borderRadius: 8 }}>
      <ListItem.Part left>
        <View style={{ flexDirection: 'row', alignItems: 'center', paddingLeft: 10 }}>
          <MaterialIcons name={premium ? "lock" : "book"} size={20} color={premium ? Colors.backgroundAccent2 : Colors.iconSecondary} />
          <View paddingL-10 style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <Text h3 color={premium ? Colors.textAccentTertiary : Colors.textPrimary}>{title}</Text>
          </View>
        </View>
      </ListItem.Part>
    </ListItem>
  )
}

/**
 *
 * @returns Simple list item component.
 */
export const ListItemSimple: FC<ListItemProps> = (
  {
    onPress,
    label,
    icon,
    selected,
    correct,
    testID
  }
) => {

  const [backgroundColor, setBackgroundColor] = useState(Colors.tertiaryBG);
  const [textColor, setTextColor] = useState();

  useEffect(() => {
    if (selected && correct === true) {
      setBackgroundColor(Colors.greenBG);
      setTextColor(Colors.textAccentSecondary);
    } else if (selected && correct === false) {
      setBackgroundColor(Colors.redBG);
      setTextColor(Colors.textAccentSecondary);
    } else if (selected) {
      setBackgroundColor(Colors.backgroundAccent);
      setTextColor(Colors.textAccentSecondary);
    } else {
      setBackgroundColor(Colors.tertiaryBG);
      setTextColor(Colors.iconSecondary);
    }
  }, [selected, correct]);

  return (
    <ListItem testID={testID} height={45} onPress={() => onPress()} backgroundColor={backgroundColor} style={{ borderRadius: 8 }}>
      <ListItem.Part middle>
        <View style={{ flexDirection: 'row', alignItems: 'center', paddingLeft: 10 }}>
          <View paddingL-10 style={{ flexDirection: 'column', alignItems: 'center' }}>
            <Text center h5 color={textColor}>
              {label}
            </Text>
          </View>
        </View>
      </ListItem.Part>
    </ListItem>
  )

}